<app-crear-editar
  [loading]="loading"
  title="Materiales asignados"
  icono="inventory_2"
  [subtitle]="usuario?.usuario"
>
  <div style="display: flex; flex-direction: column; gap: 1em">
    <!-- Alta de material -->
    <app-content-card title="Asignar material" icon="add_box" color="blue">
      <section class="inputs-group">
        <app-info-banner
          color="blue"
          icon="info"
          title="Los materiales asignados podrán verse en la sección <b>Materiales</b> de este módulo. Cuando se asigne técnico a un servicio técnico, este podrá disponer de los materiales y <b>usarlos</b> o <b>devolverlos</b>. Asimismo, podrá <b>solicitar materiales adicionales</b> si los necesita, que quedarán <b>pendientes de aprobación</b> por parte de la administración."
          [closable]="false"
          margin="0 0 8px 0"
        ></app-info-banner>

        <irx-segmentado
          [(ngModel)]="modo"
          (ngModelChange)="onModoChange()"
          class="modo-toggle"
        >
          <irx-segmento value="libre">Material libre</irx-segmento>
          <irx-segmento value="dispositivo">Dispositivo</irx-segmento>
        </irx-segmentado>

        @if (modo === 'libre') {
          <div class="fila">
            <mat-form-field class="desc">
              <mat-label>Descripción</mat-label>
              <input
                matInput
                [(ngModel)]="descripcion"
                placeholder="Ej: cable, herramienta…"
              />
              <mat-icon matPrefix>inventory_2</mat-icon>
            </mat-form-field>
            <mat-form-field class="cant">
              <mat-label>Cantidad</mat-label>
              <input matInput type="number" min="1" [(ngModel)]="cantidad" />
            </mat-form-field>
          </div>
        } @else {
          <div class="fila">
            <ng-select
              class="desc"
              placeholder="Tipo de dispositivo"
              [items]="tiposDispositivo"
              bindValue="value"
              bindLabel="label"
              [(ngModel)]="tipoEntidadSel"
              (ngModelChange)="onTipoEntidadChange()"
              appendTo="body"
              notFoundText="Sin resultados"
            ></ng-select>
            <div class="desc">
              <!-- Los dispositivos asignados a otro técnico llegan con disabled: true -->
              <ng-select
                placeholder="Dispositivo"
                [items]="entidades"
                bindValue="id"
                bindLabel="label"
                [(ngModel)]="idEntidadSel"
                [disabled]="!tipoEntidadSel || cargandoEntidades"
                [loading]="cargandoEntidades"
                appendTo="body"
                notFoundText="Sin resultados"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item.label }}
                  @if (!item.disponible) {
                    <span class="opcion-no-disponible">
                      — Asignado a {{ item.asignadoA }}
                    </span>
                  }
                </ng-template>
              </ng-select>
              @if (cargandoEntidades) {
                <small class="ayuda">Cargando…</small>
              }
            </div>
          </div>

          <app-info-banner
            color="orange"
            icon="lock"
            title="Un dispositivo del sistema solo puede estar asignado a un técnico a la vez. Si ya lo tiene otro, aparece deshabilitado; primero hay que desasignárselo a ese técnico."
            [closable]="false"
            margin="0 0 8px 0"
          ></app-info-banner>
          @if (!tiposDispositivo.length) {
            <p class="hint">No tenés módulos con dispositivos asignables.</p>
          } @else if (
            tipoEntidadSel && !cargandoEntidades && !entidades.length
          ) {
            <p class="hint">
              No hay dispositivos disponibles de este tipo para el cliente.
            </p>
          }
        }

        <app-upload-file
          textoBoton="Agregar fotos"
          [allowMultiple]="true"
          [maxFiles]="5"
          [urls]="imagenes"
          (urlsChange)="imagenes = $event"
        ></app-upload-file>

        <app-button
          matType="mat-fab extended"
          color="primary"
          text="Asignar"
          icon="add"
          [disabled]="!puedeAgregar"
          (click)="agregar()"
        ></app-button>
      </section>
    </app-content-card>

    <!-- Materiales asignados -->
    <app-content-card title="Asignados" icon="inventory" color="orange">
      <section class="inputs-group">
        @if (asignados.length) {
          <mat-list style="width: 100%">
            @for (mat of asignados; track mat._id) {
              <mat-list-item>
                <mat-icon matListItemIcon>
                  {{ mat.tipoEntidad ? 'router' : 'inventory_2' }}
                </mat-icon>
                <span matListItemTitle>
                  {{ mat.descripcion || mat.idEntidad }}
                  @if (mat.cantidad && mat.cantidad > 1) {
                    <span>×{{ mat.cantidad }}</span>
                  }
                </span>
                @if (mat.tipoEntidad) {
                  <span matListItemLine>{{ mat.tipoEntidad }}</span>
                }
                @if (mat.imagenes?.length) {
                  <span matListItemLine>
                    <mat-icon
                      style="
                        font-size: 16px;
                        height: 16px;
                        width: 16px;
                        vertical-align: middle;
                      "
                    >
                      image
                    </mat-icon>
                    {{ mat.imagenes?.length }} foto(s)
                  </span>
                }
                <button
                  irxBotonIcono
                  tono="peligro"
                  matListItemMeta
                  [disabled]="guardando"
                  (click)="quitar(mat)"
                  tooltip="Desasignar (elimina, no queda en historial)"
                >
                  <mat-icon>link_off</mat-icon>
                </button>
              </mat-list-item>
            }
          </mat-list>
        } @else {
          <p class="hint">Sin materiales asignados.</p>
        }
      </section>
    </app-content-card>
  </div>

  <ng-container actions>
    <app-button
      matType="mat-fab extended"
      color="neutral"
      text="Cerrar"
      icon="close"
      (click)="cerrar()"
    ></app-button>
  </ng-container>
</app-crear-editar>
